<template>
  <responsive-modal v-model="visible" title="Integrar Active Campaign">
    <div class="tool-modal-option">
      <a
        href="https://www.activecampaign.com"
        target="_blank"
        class="integration-link"
      >
        Conheça o Active Campaign
        <i class="ph ph-arrow-square-out" />
      </a>
      <snow-input
        value="Active Campaign"
        id="name"
        label="Nome da conta"
        :errors="errors.name"
        disabled
      />
      <snow-input
        id="description"
        label="Descrição da conta"
        v-model="form.description"
        :errors="errors.description"
      />
      <h5 class="text-dark-40">
        A descrição da conta ajuda na identificação interna, entre os produtos
        do ZeusPay.
      </h5>
      <snow-input
        v-model="form.url"
        id="url"
        label="API URL"
        :errors="errors.url"
      />
      <snow-input
        v-model="form.token"
        id="token"
        label="API Key"
        :errors="errors.token"
      />

      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="visible = false"
        />
        <snow-button
          size="lg"
          :text="editedProvider ? 'Salvar' : 'Integrar'"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>

<script>
import { formFields } from "../../../functions/helpers";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editedProvider: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["name", "url", "token", "description"], {
        name: "active_campaign"
      }),
      visible: false,
      loading: false
    };
  },
  computed: {
    isValid() {
      return this.form.url && this.form.token && this.form.description;
    }
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    editedProvider(v) {
      if (v) {
        this.form = {
          ...v
        };
      }
    }
  },
  methods: {
    clear() {
      this.$emit("clear-edit");
      this.form = formFields(["name", "url", "token", "description"], {
        name: "active_campaign"
      });
    },
    submit() {
      let mistakeMsg = "";

      ["https://", ".com"].forEach(term => {
        if (this.form.url.indexOf(term) === -1) {
          mistakeMsg = "Digite uma url válida";
        }
      });

      if (mistakeMsg.length) {
        this.$message.error(mistakeMsg);
        return;
      }

      this.loading = true;

      let action = "integration/postProvider";
      let form = { ...this.form };
      if (this.editedProvider) {
        action = "integration/putProvider";
        form.id = this.editedProvider.id;
      }

      this.$store
        .dispatch(action, form)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          this.visible = false;
          this.clear();
          this.$emit("refresh");
        })
        .catch(error => {
          let errorMsg = "Erro ao salvar";
          if (error.response?.data?.message) {
            errorMsg = error.response?.data?.message.split(".")[0];
          }
          this.$message.error(errorMsg);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-option {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
